export const APP_GROUPS = [
  "admin",
  "directivos",
  "uploaders",
  "viewers",
  "governance",
  "ocesa-rag-users",
  "quicksight-viewer",
  "ocesa-commercial-users",
];

export const getUserGroups = (user) => {
  const rawGroups = user?.profile?.["cognito:groups"] || [];

  if (Array.isArray(rawGroups)) {
    return rawGroups;
  }

  if (typeof rawGroups === "string") {
    return [rawGroups];
  }

  return [];
};

export const getPermissions = (user) => {
  const groups = getUserGroups(user);

  const isAdmin = groups.includes("admin");
  const isCommercial = groups.includes("ocesa-commercial-users");

  // Admin gana sobre directivo.
  const isDirectivo = groups.includes("directivos") && !isAdmin;

  // Esto ignora el grupo automático de SAML:
  // us-east-1_xxxxx_OCESA-SAML
  const hasAssignedRole = groups.some((group) => APP_GROUPS.includes(group));

  const canUpload = !isDirectivo && (isAdmin || groups.includes("uploaders"));

  const canViewFiles = !isDirectivo && (isAdmin || groups.includes("viewers"));

  const canViewData = !isDirectivo && (isAdmin || groups.includes("governance"));

  const canViewReports =
    isAdmin || isDirectivo || isCommercial || groups.includes("viewers");

  const canViewDashboards =
    isAdmin || isDirectivo || isCommercial || groups.includes("quicksight-viewer");

  // Importante:
  // Backstage AI / RAG se activa por el grupo del backend.
  // Si el backend requiere ocesa-rag-users, el front también debe pedirlo.
  const canUseBackstageAI = groups.includes("ocesa-rag-users");

  return {
    groups,
    isAdmin,
    isDirectivo,
    hasAssignedRole,
    canUpload,
    canViewFiles,
    canViewData,
    canViewReports,
    canViewDashboards,
    canUseBackstageAI,
  };
};

export const canAccessView = (view, permissions) => {
  switch (view) {
    case "welcome":
      return true;

    case "upload":
      return permissions.canUpload;

    case "viewFiles":
    case "FileExplorer":
      return permissions.canViewFiles;

    case "data":
      return permissions.canViewData;

    case "ReportsView":
      return permissions.canViewReports;

    case "DashboardsView":
      return permissions.canViewDashboards;

    case "chatInterface":
      return permissions.canUseBackstageAI;

    default:
      return false;
  }
};
